import { useState } from "react";
import { Box, Grid } from "@mui/material";
import PaperCard from "../../../components/ui/PaperCard";
import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import InfoIcon from "./../../../assets/images/icons/info.png";
import { messages } from "../../../data/constant";

type Props = {
  sectionName?: string;
};

const PermissionView = ({ sectionName }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Grid container spacing={2}>
      {/* Left Section */}
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <PaperCard>
          {/* Dashboard data */}
          <Box
            sx={{
              height: "100px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "5px",
              color: "#666666",
            }}
          >
            <img src={InfoIcon} alt="Info Icon" />
            <Box>
              {messages.noPermission.module} "
              {sectionName ? sectionName : "section"}"{" "}
            </Box>
          </Box>
        </PaperCard>
      </Grid>
      <LoaderBackdrop open={isLoading} />
    </Grid>
  );
};

export default PermissionView;
